"use client";

import {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
} from "@/components/ui/command";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { cn } from "@/lib/utils";
import { useScopedI18n } from "@/messages/client";

import { useState } from "react";

export default function QuerySelect(props: {
  options?: {
    value: string;
    label: string;
  }[];
  children?: React.ReactNode;
  className?: string;
  onChange?: (value: string) => void;
  value?: string;
}) {
  const t = useScopedI18n("全局组件");

  const [open, setOpen] = useState(false);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>{props.children}</PopoverTrigger>
      <PopoverContent
        className={cn(
          "border-[#C2C6CE] bg-white p-0 outline-none",
          props.className
        )}>
        <Command>
          <div className="p-2">
            <CommandInput
              className="h-8 border border-[#C2C6CE] px-4 text-sm focus:border-[#FF5100]"
              placeholder={t("搜索")}
            />
          </div>
          <CommandList>
            <CommandEmpty>{t("内容为空")}</CommandEmpty>
            <CommandGroup>
              {props.options?.map((option) => (
                <CommandItem
                  key={option.value}
                  className={cn(
                    "cursor-pointer text-sm transition-colors duration-300 hover:text-[#FF5100]",
                    {
                      "bg-[#F4F4F4] text-[#FF5100]":
                        option.value === props.value,
                    }
                  )}
                  onSelect={() => {
                    if (option.value === props.value) {
                      return;
                    }

                    props.onChange?.(option.value);

                    setOpen(false);
                  }}>
                  {option.label}
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
}
